import { AnalyticsService } from '../analytics.service';
/** @format */
/* eslint-disable @nx/enforce-module-boundaries */
import { ExpressCheckoutError } from '@cart-checkout/data-access/interfaces';
import { ExpressCheckoutErrorLogKeys } from '@cart-checkout/data-access/enums';
import { Injectable } from '@angular/core';
import { LoggerLevel } from '../enums/logger-level.enum';

@Injectable({
  providedIn: 'root',
})
export class ExpressCheckoutAnalyticsService extends AnalyticsService {
  public generateLogError(
    errorKey: ExpressCheckoutErrorLogKeys | string,
    errorMessage: string,
    errorObject: Error = undefined,
    additionalData: Partial<ExpressCheckoutError> = undefined,
    logLevel: LoggerLevel = LoggerLevel.ERROR,
  ) {
    const error: ExpressCheckoutError = {
      Error: errorObject,
      ErrorMessage: errorMessage,
      PageType: this.window.siteData?.PageType,
      CheckoutStep: this.window.siteData?.CheckoutStep,
      OrderNumber: this.cookieService.get('X-DCSG-EXPRESS-CHECKOUT'),
      LoyaltyID: this.window.siteData?.LoyaltyID,
      CartId: this.window.siteData?.CartID,
      Chain: this.window.siteData?.Chain,
      AppId: this.window.siteData?.appID,
      Authenticated: this.window.siteData?.LoggedIn,
      ReferringPageURL: `${this.document?.referrer}`,
      X_HREF: `${this.window.location?.protocol}//${this.window.location?.host}${this.window.location?.pathname}`,
      DSG_UID: this.cookieService.get('DSG_UID'),
    };

    super.generateLogError(errorKey, errorMessage, error, additionalData, logLevel);
  }
}
